import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcel, getDealers, searchDealers, updateCredits } from '@/api/dealers';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
import { getAgentById } from '@/api/agents';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import { AdminModule } from '@/store/modules/admin';
import { cleanListQuery, isAdmin, isExcludedToAccess, isBranchManager, isSuperAdmin } from '@/common';
import { BranchAgentService } from '@/services/branch-agent-service';
import { BRANCH_MANAGER, ZONAL_MANAGER } from '@/constants/roles.constants';
import { getAdmins } from '@/api/admins';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.branchListLoading = false;
    this.branchList = [];
    this.isAgent = false;
    this.agentList = [];
    this.stateList = [];
    this.cityList = [];
    this.dealerList = [];
    this.agentUserList = [];
    this.dealerListLoading = false;
    this.dateRange = '';
    this.startDate = '';
    this.endDate = '';
    this.statusColorMap = {
      Pending: 'info',
      Approved: 'success',
      Blocked: 'danger',
      Hold: 'warning'
    };
    this.showFilters = false;
    this.assignedBranches = [] || null;
    this.salesExecutiveAdmins = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      id: undefined,
      enabled: true,
      isMonthlyCashDiscountApplicable: undefined,
      isCollectible: '',
      code: undefined,
      'address.gstNumber': undefined,
      status: undefined,
      agentId: undefined,
      branchId: undefined,
      applyBranchIdFilter: true,
      fromDealer: true,
      'address.stateId': undefined,
      city: undefined,
      'assignedAgents.id': undefined,
      "['mappedAdmins.id']": undefined,
      sort: 'id,ASC',
      createdTimestamp: undefined,
      filter: {
        id: '$eq',
        enabled: '$eq',
        isMonthlyCashDiscountApplicable: '$eq',
        isCollectible: '$eq',
        code: '$startsL',
        'address.gstNumber': '$contL',
        status: '$eq',
        agentId: '$eq',
        branchId: '$in',
        'address.stateId': '$eq',
        city: '$eq',
        'assignedAgents.id': '$eq',
        'mappedAdmins.id': '$eq',
        createdTimestamp: 'between'
      }
    };
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.getAdminByRole = (mappedAdmins, roleName) => {
      try {
        if (!mappedAdmins || !Array.isArray(mappedAdmins)) return 'N/A';
        // Find admin with the specified role
        const admin = mappedAdmins.find(admin => {
          var _admin$adminsRole;
          return admin === null || admin === void 0 || (_admin$adminsRole = admin.adminsRole) === null || _admin$adminsRole === void 0 ? void 0 : _admin$adminsRole.some(role => (role === null || role === void 0 ? void 0 : role.name) === roleName);
        });
        return admin ? admin.fullName : 'N/A';
      } catch (err) {
        console.error(`Error processing ${roleName} admin:`, err);
        return 'Error';
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
    this.CDtypeOptions = [{
      key: true,
      value: 'Applicable'
    }, {
      key: false,
      value: 'Not-Applicable'
    }];
    this.collectibleTypeOptions = [{
      key: '',
      value: 'All'
    }, {
      key: true,
      value: 'Collectable'
    }, {
      key: false,
      value: 'Non-Collectable'
    }];
  }
  // Some agents (e.g. "DIRECT", used to bucket dealers with no assigned
  // field agent) fail the backend's GET /agents/:id business filter (dealer/
  // agentUser enabled checks meant for the agents list view) and 404 even
  // though the id is valid. Fail soft here rather than let it surface as an
  // unhandled error - an agent with no eligible Sales Executives should just
  // mean an empty dropdown, not a broken filter.
  async fetchAgentUsers(agentId) {
    try {
      const agentData = await getAgentById(agentId);
      return (agentData.agentUser || []).filter(user => user.roles.some(role => role.name === 'Sales Executive'));
    } catch (error) {
      return [];
    }
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [BRANCH_MANAGER, ZONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  isSalesExecutiveAdmin() {
    return isBranchManager();
  }
  async activated() {
    try {
      // Extract branchId from the URL
      const branchIdFromURL = Number(this.$route.query.branchId);
      if (this.$route.query.agentId) {
        this.listQuery.agentId = Number(this.$route.query.agentId);
        this.agentUserList = await this.fetchAgentUsers(this.listQuery.agentId);
      }
      if (this.$route.query.assginedAgentId) {
        this.listQuery['assignedAgents.id'] = Number(this.$route.query.assginedAgentId);
      }
      // If branchId exists in the URL, assign it
      if (branchIdFromURL) {
        this.listQuery.branchId = branchIdFromURL;
      }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      // check if logged in user is Agent/Admin
      if (AdminModule.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = AdminModule.agentId;
      }
      this.fetchSalesExecutiveManagers();
      await this.getList();
      // get state list
      this.fetchStates();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      this.listLoading = true;
      const data = await getDealers(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.listQuery.createdTimestamp = [this.startDate, this.endDate].join(',');
    } else {
      this.listQuery.createdTimestamp = '';
    }
    if (this.listQuery.agentId) {
      this.agentUserList = await this.fetchAgentUsers(this.listQuery.agentId);
    }
    // Check if stateId exists in listQuery and fetch cities
    if (this.listQuery['address.stateId']) {
      this.fetchCitiesByState(this.listQuery['address.stateId']);
    }
    // Reset the page to 1 on filter change
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      // this.listQuery = cleanListQuery(this.listQuery);
      this.getList();
    } else {
      this.getList();
    }
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  sortChange(data) {
    this.handleFilter();
  }
  async fetchStates() {
    this.stateList = await getStates(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchCitiesByState(stateId = 0) {
    this.cityList = await getCities(getQuery({
      enabled: true,
      stateId,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq',
        stateId: '$eq'
      }
    }));
  }
  async handleDownload() {
    this.listQuery = cleanListQuery(this.listQuery);
    this.downloadLoading = true;
    const tHeader = ['ID', 'Name', 'Code'];
    const filterVal = ['id', 'name', 'code'];
    const agentFilter = Object.assign({}, this.listQuery);
    delete agentFilter.limit;
    delete agentFilter.page;
    const dealers = await getDealers(getQuery(agentFilter));
    const data = formatJson(filterVal, dealers);
    exportJson2Excel(tHeader, data, this.$tc('route.dealerManagement.dealer.title'));
    this.downloadLoading = false;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleUpdateCredits() {
    try {
      await this.$confirm('Are you sure you want to update credits?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      await updateCredits();
      this.$message.success('Credits updated successfully');
      this.getList();
    } catch (error) {
      this.$message.error('Credits Not Updated');
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      const blob = await downloadExcel(getQuery(queryWithoutPagination));
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'dealers.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'DealerList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;